import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { reportSample } from '../api/reportService'
import Main from '../Report/components/Main'
import { getThemeConfig, ThemeConfig } from '../utils/themeConfig'
import { Center, Loader } from '@mantine/core'
import SampleWatermark from '../components/SampleWatermark'

export default function Sample() {
  const navigate = useNavigate()
  let { templateId } = useParams()
  const [data, setData] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [themeConfig, setThemeConfig] = useState<ThemeConfig>()

  useEffect(() => {
    if (templateId === '') {
      navigate('/error')
    }
    const fetchData = async () => {
      reportSample(templateId!)
        .then((res) => {
          setData(res)
          setThemeConfig(getThemeConfig((res as any).templateThemeType as number))
        })
        .catch((err) => {})
        .finally(() => setIsLoading(false))
    }
    fetchData().then()
  }, [navigate, templateId])

  if (isLoading || !themeConfig) {
    return (
      <Center h="100vh">
        <Loader color="#5087EB" size="lg" type="dots" />
      </Center>
    )
  }

  return (
    <>
      <SampleWatermark />
      <Main data={data} isLoading={isLoading} theme={themeConfig} />
    </>
  )
}
